import { validators } from '../../utils/validators';

const getMsg = selectedTab => {
    if (selectedTab === 'WEBHOOK') {
        return 'url';
    } else if (selectedTab === 'SMS') {
        return 'mobile number';
    }
    return 'email';
};

const validate = (values, props) => {
    const { selectedTab } = props;
    const { REQUIRED, EMAIL, PHONE_NUMBER, URL } = validators;
    const errors = {};
    if (selectedTab === 'EMAIL' && EMAIL(values.identifier)) {
        errors.identifier = 'Please enter a valid email';
    }
    if (selectedTab === 'SMS' && PHONE_NUMBER(values.identifier)) {
        errors.identifier = 'Please enter a valid mobile number';
    }
    if (selectedTab === 'WEBHOOK' && URL(values.identifier)) {
        errors.identifier = 'Please enter a valid url';
    }
    if (REQUIRED(values.identifier)) {
        errors.identifier = `Please enter ${getMsg(selectedTab)}`;
    }
    if (REQUIRED(values.entityCodes)) {
        errors.entityCodes = 'Please select merchant';
    }
    if (REQUIRED(values.eventsList)) {
        errors.eventsList = 'Please select atleast one event';
    }
    if (selectedTab === 'WEBHOOK' && REQUIRED(values.version)) {
        errors.version = 'Please select version';
    }
    return errors;
};

export default validate;
